/**
 * Documentos que el solicitante debe cargar por el portal público.
 * En gestión interna no se suben aquí salvo administrador de proyectos.
 */
export const DOCUMENTOS_SOLO_CARGA_SOLICITANTE = new Set<string>([
  "factibilidad_plano_diseno",
  "factibilidad_presupuesto_diseno",
  "gestion_doc_carta_remisoria",
  "gestion_doc_ley_1581_propietario",
  "gestion_doc_ley_1581_contratista",
  "gestion_doc_cedula_representante_legal",
  "gestion_doc_matricula_cedula_ingeniero",
  "gestion_doc_presupuesto_electrico",
  "gestion_doc_diagrama_unifilar",
  "gestion_doc_carta_autorizacion",
  "gestion_doc_solicitud_creg_e1",
  "gestion_doc_camara_comercio",
  "gestion_doc_autodeclaracion_retie",
  "gestion_doc_rut",
  "gestion_doc_permisos_licencias",
  "gestion_doc_certificado_tradicion",
  "gestion_doc_declaracion_cumplimiento_disenada",
  "revision_doc_certificado_libertad",
  "revision_doc_declaracion_cumplimiento_deudas",
  "revision_doc_acta_levantada_terreno",
  "revision_doc_carta_remisoria",
  "revision_doc_comprobante_pago_diseno",
  "ejecucion_doc_acta_visita",
]);

export function documentoRequiereCargaSoloSolicitante(tipoDocumento: string): boolean {
  const safe = String(tipoDocumento || "")
    .replace(/[^a-z0-9_]/gi, "")
    .toLowerCase();
  return DOCUMENTOS_SOLO_CARGA_SOLICITANTE.has(safe);
}
